import { useEffect, useLayoutEffect } from 'react';
import { useParams } from 'react-router-dom';
import { projects } from '../constants';
import { updatePageMeta } from '../utils/seo';
import ProjectDetail from '../components/project/ProjectDetail';
import NotFound from './NotFound';

function ProjectPage() {
  const { slug } = useParams();
  const project = projects.find(p => p.slug === slug);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  useEffect(() => {
    if (project) {
      const description = project.description || `Portfolio project: ${project.title}. ${project.overview?.paragraphs?.[0] || 'UI/UX design work by Stephanie Zhang.'}`;
      updatePageMeta(
        `${project.title} - Stephanie Zhang`,
        description
      );
    } else {
      updatePageMeta(
        'Page Not Found - Stephanie Zhang',
        'The requested page could not be found.'
      );
    }
  }, [project]);

  if (!project) {
    return <NotFound />;
  }

  return <ProjectDetail project={project} />;
}

export default ProjectPage;

